import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { AppModulesType } from '../../../../_shared/enums/appModulesType.enum';
import { ActiveModulesService } from '../../../../_shared/services/activeModules.service';
import { SimilarCustomersService } from '../../../../_shared/services/similar-customers.service';
import { ReservationService } from '../_services';
import { ReservationType } from './../../../../_shared/enums/schedule/reservationType.enum';
import { Event } from './../../../../_shared/model/event.model';
import { HelperNavigateService } from './../../../../_shared/services/helper-navigate.service';
import { HelperService } from './../../../../_shared/services/helper.service';
import { MfToastService } from './../../../../_shared/services/mfToast.service';
import { StorageService } from './../../../../_shared/services/storage.service';
import { GetAndLoadServices } from './../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../_shared/state/base/base.state';
import { CustomerService } from './../_services/customer.service';

// TODO Ignored with eslint-interactive on 2023-11-10
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

@Injectable({
    providedIn: 'root',
})
export class MainCalendarHelperService {
    private onDestroy$ = new Subject<void>();
    private cid: number = this.store.selectSnapshot(BaseState.activeContractorId);
    private isHDModuleActive = this.activeModules.isAM(AppModulesType.HELLO_DOCTOR);

    constructor(
        private reservationRest: ReservationService,
        private storage: StorageService,
        private store: Store,
        private customerRest: CustomerService,
        private modalService: NgbModal,
        private toast: MfToastService,
        private navigationHelper: HelperNavigateService,
        private helper: HelperService,
        private activeModules: ActiveModulesService,
        private similarCustomersService: SimilarCustomersService,
    ) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadServicesToCache(): Observable<any> {
        return this.store.dispatch(new GetAndLoadServices()).pipe(
            mergeMap(() => this.store.select(BaseState.getServices())),
            takeUntil(this.onDestroy$),
        );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public manageResourceHeader(data: any, element: any): void {
        if (_.get(element, 'innerHTML')) {
            element.innerHTML = data.title
                .split(' ')
                .map((el: string) => el[0])
                .join('');
            $(element[0]).tooltip({ title: data.title });
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getSelectedBusinessHours(businessHours: any[], start: moment.Moment): void {
        if (_.isNil(businessHours)) {
            return;
        }
        for (const bh of businessHours) {
            if (bh.daysOfWeek[0] === moment(start).day()) {
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const startBH: any[] = bh.startTime.split(':');
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const endBH: any[] = bh.endTime.split(':');
                if (!moment.isMoment(start)) {
                    start = moment(start);
                }
                const from: moment.Moment = start.clone().hours(startBH[0]).minutes(startBH[1]);
                const to: moment.Moment = start.clone().hours(endBH[0]).minutes(endBH[1]);
                if (start.isBetween(from, to, 'minute', '[]')) {
                    return bh;
                }
            }
        }
        return;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createSimpleReservation(data: any): Observable<any> {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataIn: any = {
            contractor: data.contractor,
            from: data.start,
            to: data.end,
            comment: data.comment,
            customTagId: data.customTagId,
            service: data.service,
            asset: data.asset,
            customer: data.customer,
            recurringId: data.recurringId,
            forceUpdate: true,
            reservationType: ReservationType.EA,
        };
        return this.reservationRest.sendPreResevation(dataIn).pipe(
            mergeMap(res => {
                this.reservationRest.sendResevation(res);
                return res;
            }),
        );
    }

    public findSimilarCustomers(resRequestData: Event): void {
        this.similarCustomersService.findSimilarCustomers(this.cid, resRequestData, true).subscribe();
    }
}
